import { render, staticRenderFns } from "./DocStatus.vue?vue&type=template&id=097dad61"
import script from "./DocStatus.vue?vue&type=script&lang=js"
export * from "./DocStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports